import { postFetcherV2 } from "shared/api/api";
import { usePostAPI } from "shared/api/hooks";

import {
  getLatestIngestionsRequestURI,
  LatestIngestion,
  LatestIngestionsRequest,
  LatestIngestionView,
} from "./api";

export const useLatestIngestions = (
  args: LatestIngestionsRequest,
  views: LatestIngestionView[]
) =>
  usePostAPI<typeof args, LatestIngestion[]>(
    getLatestIngestionsRequestURI,
    args,
    { views },
    { dedupingInterval: 10 * 60 * 1000, revalidateOnFocus: false },
    postFetcherV2
  );
